module.exports = __webpack_public_path__ + "static/wordmark-d2827f108047de87ee131a7181249c37.svg";